import { SxProps, Theme } from "@mui/material";

export const DRAWER_WIDTH = 260;

export const PAGE_MAX_WIDTH = 1200;

export const WEEKLY_HOURS_TARGET = 40;

export const GAUGE_ARC_LENGTH = 141.37;

export enum ProjectStatus {
  ACTIVE = "active",
  PENDING = "pending",
  COMPLETED = "completed",
}

export const PROJECT_STATUS_COLORS: Record<
  ProjectStatus,
  "success" | "primary" | "default"
> = {
  [ProjectStatus.ACTIVE]: "success",
  [ProjectStatus.PENDING]: "primary",
  [ProjectStatus.COMPLETED]: "default",
};

export const PROJECT_STATUS_DOT_COLORS: Record<ProjectStatus, string> = {
  [ProjectStatus.ACTIVE]: "primary.main",
  [ProjectStatus.PENDING]: "warning.main",
  [ProjectStatus.COMPLETED]: "grey.400",
};

export enum Currency {
  EUR = "EUR",
  USD = "USD",
}

export const CURRENCY_OPTIONS = Object.values(Currency);

export const COUNTRY_CODE_LENGTH = 2;

export const TABLE_HEADER_SX: SxProps<Theme> = {
  fontWeight: 700,
  textTransform: "uppercase",
  fontSize: 11,
  letterSpacing: "0.05em",
};

export const LABEL_CAPS_SX: SxProps<Theme> = {
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  fontWeight: 600,
};

export const PULSE_KEYFRAMES = {
  "@keyframes pulse": {
    "0%, 100%": { opacity: 1 },
    "50%": { opacity: 0.3 },
  },
};

export const PULSE_DOT_SX: SxProps<Theme> = {
  width: 8,
  height: 8,
  bgcolor: "success.main",
  borderRadius: "50%",
  animation: "pulse 1.5s infinite",
  ...PULSE_KEYFRAMES,
};

export const DELETE_CONFIRM_KEYWORD = "DELETE";
